<template>
  <footer class="footer">
    <div class="container">
      <!-- 上部分四栏内容 -->
      <div class="footer-content">
        <!-- 协会介绍 -->
        <div class="footer-col">
          <div class="footer-logo">
           <!-- <div> -->
             <!-- <img src="@/assets/logo.jpg" alt="logo" class="qrcode-img"> -->
           <!-- </div> -->

            <!-- <iconify-icon icon="mdi:application" class="logo-icon"></iconify-icon> -->
            <h4>昆山市电子信息服务和集成电路行业协会</h4>
          </div>
          <p class="footer-desc">
            连接产业、服务企业、赋能人才。
          </p>
          <p class="footer-desc">
           我们是昆山软件产业发展的坚实伙伴。
          </p>
        </div>

        <!-- 快捷链接 -->
        <div class="footer-col">
          <h4 style="text-align: left;">快捷链接</h4>
          <ul class="footer-links">
            <li><a @click="goToAbout" style="cursor: pointer;">协会介绍</a></li>
            <li><a @click="goToServices" style="cursor: pointer;">服务指南</a></li>
            <li><a @click="goToMembers" style="cursor: pointer;">会员名录</a></li>
            <li><a @click="goToPolicy" style="cursor: pointer;">政策法规</a></li>
          </ul>
        </div>

        <!-- 联系我们 -->
        <div class="footer-col">
          <h4 style="text-align: left;">联系我们</h4>
          <ul class="contact-list">
            <li>
              <iconify-icon icon="mdi:map-marker" class="contact-icon"></iconify-icon>
              昆山市巴城镇浦东软件园
            </li>
            <!-- <li>
              <iconify-icon icon="mdi:phone" class="contact-icon"></iconify-icon>
              0512-5700XXXX
            </li> -->
            <li>
              <iconify-icon icon="mdi:email" class="contact-icon"></iconify-icon>
              servers@kssia.com.cn
            </li>
          </ul>
        </div>

        <!-- 关注我们 -->
        <div class="footer-col">
          <h4 style="text-align: left;">关注我们</h4>
<!--          <div class="social-icons">-->
<!--            <a href="#" class="social-icon">
              <iconify-icon icon="mdi:wechat"></iconify-icon>
            </a>-->
            <!--              <a href="#" class="social-icon">
                            <iconify-icon icon="mdi:weibo"></iconify-icon>
                          </a>-->
<!--          </div>-->
          <div class="qrcode-box">
            <img src="@/assets/wxcode.jpg" alt="公众号二维码" class="qrcode-img">
            <p class="qrcode-tip">微信扫码关注公众号</p>
          </div>
        </div>
      </div>

      <!-- 分割线 -->
      <div class="divider"></div>

      <!-- 版权信息 -->
      <div class="copyright">
        © 2026昆山市电子信息服务和集成电路行业协会 版权所有 | <span class="icp" @click="goLink">苏ICP备2026049006号-1 </span>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "PageFooter",
  data() {
    return {

    };
  },
  methods: {
    goToAbout() {
      this.$router.push({
        name: 'About',
      })
    },
    goToServices() {
      this.$router.push({
        name: 'Services',
      })
    },
    goToMembers() {
      this.$router.push({
        name: 'Members',
      })
    },
    goToPolicy() {
      this.$router.push({
        name: 'Policy',
      })
    },
    goLink() {
      window.open('https://beian.miit.gov.cn/#/Integrated/index', '_blank');
    }
  }
};
</script>

<style scoped lang="scss">
.footer {
  background-color: #0f172a;
  color: rgba(255, 255, 255, 0.8);
  padding: 60px 0 30px;
  font-size: 15px;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.footer-content {
  display: grid;
  grid-template-columns: 2.5fr 1fr 1.5fr 1.5fr;
  gap: 40px;
  margin-bottom: 40px;
}

.footer-col {
  display: flex;
  flex-direction: column;
}

.footer-logo {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 16px;
}
.logo-icon {
  font-size: 26px;
  color: #fff;
}
.footer-logo h4 {
  color: #fff;
  font-size: 24px;
  font-weight: 600;
  margin: 0;
  margin-bottom: 0!important;
}
.footer-desc {
  line-height: 1.8;
  margin: 0;
  text-align: left;
}

.footer-col h4 {
  color: #fff;
  font-size: 18px;
  font-weight: 600;
  margin: 0 0 20px;
}

.footer-links {
  list-style: none;
  padding: 0;
  margin: 0;
}
.footer-links li {
  margin-bottom: 12px;
  text-align: left;
}
.footer-links a {
  color: rgba(255, 255, 255, 0.7);
  text-decoration: none;
  transition: color 0.3s;
}
.footer-links a:hover {
  color: #fff;
}

.contact-list {
  list-style: none;
  padding: 0;
  margin: 0;
}
.contact-list li {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 16px;
  line-height: 1.6;
  text-align: left;
}
.contact-icon {
  color: #3b82f6;
  font-size: 18px;
}

.social-icons {
  display: flex;
  gap: 16px;
  margin-bottom: 20px;
}
.social-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  background-color: rgba(255, 255, 255, 0.1);
  border-radius: 50%;
  color: rgba(255, 255, 255, 0.7);
  font-size: 24px;
  text-decoration: none;
  transition: background-color 0.3s;
}
.social-icon:hover {
  background-color: rgba(255, 255, 255, 0.2);
}

.qrcode-box {
  text-align: left;
}
.qrcode-img {
  width: 120px;
  height: 120px;
  object-fit: contain;
  margin-bottom: 8px;
}
.qrcode-tip {
  margin: 0;
  color: rgba(255, 255, 255, 0.6);
  font-size: 14px;
  text-align: left;
}

.divider {
  height: 1px;
  background-color: rgba(255, 255, 255, 0.15);
  margin-bottom: 30px;
}

.copyright {
  text-align: center;
  color: rgba(255, 255, 255, 0.6);
  font-size: 14px;
}
.icp {
  cursor: pointer;
}
.icp:hover {
  color: rgba(255, 255, 255, 0.9);
}

@media (max-width: 768px) {
  .footer-content {
    grid-template-columns: 1fr;
    gap: 30px;
  }
  .footer-col {
    text-align: center;
  }
  .footer-logo {
    justify-content: center;
  }
  .contact-list li {
    justify-content: center;
  }
  .social-icons {
    justify-content: center;
  }
}
</style>
